<template>
  <button :href="url" class="o-playlist__button o-preview" :class="{ playing: isPlaying }" @click.prevent="togglePlay">
    <SvgIcon icon="play" class="o-icon--track" v-if="!isPlaying" />
    <SvgIcon icon="stop" class="o-icon--track" v-if="isPlaying" />
  </button>
</template>

<script>
import {Howl, Howler} from 'howler';

export default {
  name: 'PreviewTrack',
  data() {
    return {
      player: null,
      isPlaying: false
    };
  },
  props: [
    'url',
  ],
  methods: {
    initPlayer() {
      this.player = new Howl({
        src: this.url,
        autoplay: true
      })

      this.player.on('play', () => { this.isPlaying = true });
      this.player.on('end', this.onEnded);
      this.player.on('stop', this.onEnded);
    },

    togglePlay() {
      if (!this.player) { 
        Howler.stop() // Stop all other players
        this.initPlayer();
      } else if (this.player.playing()) {
        this.player.stop()
      } else {
        Howler.stop() // Stop all other players
        this.player.play()
      }
    },

    onEnded() {
      this.isPlaying = false
    }
  },
  beforeDestroy() {
    if (this.player && this.player.unload) {
      this.player.unload()
    }
  },
};
</script>
